'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import { SESSION_REFETCH_INTERVAL } from '@/lib/auth';

interface SessionProviderProps {
  children: React.ReactNode;
  /** 세션 갱신 간격 (밀리초, 기본: 4분) */
  refetchInterval?: number;
  /** 윈도우 포커스 시 세션 갱신 여부 (기본: true) */
  refetchOnWindowFocus?: boolean;
}

/**
 * NextAuth SessionProvider 래퍼
 * 자동 세션 갱신 기능 포함
 */
export function SessionProvider({
  children,
  refetchInterval = SESSION_REFETCH_INTERVAL,
  refetchOnWindowFocus = true,
}: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      // 세션 자동 갱신 간격 (4분마다 체크)
      // Access Token 만료(5분) 전에 갱신되도록 설정
      refetchInterval={refetchInterval / 1000} // 초 단위로 변환
      // 윈도우 포커스 시 세션 갱신
      refetchOnWindowFocus={refetchOnWindowFocus}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
